export default     {
    prompt:"What font is the text?",
    field:"font",
    type:"class",
    fontSelector:true,
    default:"tahoma"
}